import React, { Component } from 'react';
import Formulario from './InformesForm';

class Informes extends Component{
    componentDidMount = () => {
        const { getModulo, listarStatus, listarPaises } = this.props;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
        listarStatus();
        listarPaises();
    }
    render(){
        const { loader, modulo, reporteMarcas, listStatus, 
                excelMarcas, listarMarcas, listPais } = this.props;
        return(
            <div>
                <Formulario
                    loader = {loader}
                    modulo = {modulo}
                    reporteMarcas = {reporteMarcas}
                    estatus = {listStatus}
                    excelMarcas = {excelMarcas}
                    listarMarcas = {listarMarcas}
                    listPais = {listPais}
                />
            </div>
        );
    }
}

export default Informes;
